import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=ffb53d8a&scoped=true&"
import script from "@/views/Groups/Groups.ts?vue&type=script&lang=ts&"
export * from "@/views/Groups/Groups.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Groups/groups.scss?vue&type=style&index=0&id=ffb53d8a&prod&lang=scss&scoped=true&"
import style1 from "../Users/users.scss?vue&type=style&index=1&id=ffb53d8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb53d8a",
  null
  
)

export default component.exports